var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.88034V15.9783C16.4995 16.1687 16.4465 16.3554 16.3464 16.5189C16.2464 16.6825 16.103 16.8168 15.9313 16.9078C15.7738 16.9924 15.5965 17.0355 15.4167 17.0331H12.1667C12.023 17.0331 11.8852 16.9775 11.7837 16.8786C11.6821 16.7797 11.625 16.6456 11.625 16.5057V13.3414C11.625 13.2015 11.5679 13.0673 11.4664 12.9684C11.3648 12.8695 11.227 12.814 11.0833 12.814H8.91668C8.77302 12.814 8.63525 12.8695 8.53366 12.9684C8.43208 13.0673 8.37501 13.2015 8.37501 13.3414V16.5057C8.37501 16.6456 8.31795 16.7797 8.21636 16.8786C8.11478 16.9775 7.97701 17.0331 7.83335 17.0331H4.58335C4.42967 17.0337 4.27764 17.0022 4.1375 16.9408C3.99735 16.8794 3.87233 16.7895 3.77085 16.6771C3.59473 16.4745 3.49869 16.2174 3.50001 15.9519V9.88034C3.50006 9.73399 3.53139 9.58925 3.592 9.45532C3.65262 9.3214 3.74119 9.20122 3.8521 9.10243L9.26876 4.30975C9.46847 4.13186 9.72934 4.0332 10 4.0332C10.2707 4.0332 10.5316 4.13186 10.7313 4.30975L16.1479 9.10243C16.2588 9.20122 16.3474 9.3214 16.408 9.45532C16.4686 9.58925 16.5 9.73399 16.5 9.88034Z",
    stroke: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a0259627f84763acb48bf76208de50cb.svg";
export { ForwardRef as ReactComponent };